import { useQuery } from "@tanstack/react-query";
import { fetchGETRequest } from "../utils/services";

export interface Ticket {
  TicketId: number;
  TicketNumber: string;
  Title: string;
  Description: string;
  Priority: number;
  Status: number;
  Category: string;
  CreatedBy: string;
  AssignedTo: string | null;
  CreatedAt: string;
  UpdatedAt: string;
}

const fetchDeviceTickets = async (deviceId: string): Promise<Ticket[]> => {
  if (!deviceId) return [];

  const response = await fetchGETRequest<{ data: Ticket[] }>(
    `devices/${deviceId}/tickets`,
  );
  return response?.data || [];
};

const useDeviceTickets = (deviceId: string) => {
  return useQuery({
    queryKey: ["deviceTickets", deviceId],
    queryFn: () => fetchDeviceTickets(deviceId),
    enabled: !!deviceId,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
};

export default useDeviceTickets;
